import {
  ColumnKeys,
  DISPLAYED_COLUMNS,
  getColumnDetails,
  MdrSecurityTelemetryExclusionsWebComponentSchema,
} from '../types';
import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, ViewType } from '../../../grid/gridView/types';
import { Filter } from '../../../grid/gridFilters/types';

export class MdrSecurityTelemetryExclusionsGridDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<MdrSecurityTelemetryExclusionsWebComponentSchema> {
    const view = {
      id: 'mdr-exclusions-grid',
      name: 'Default MDR Security Telemetry Exclusions grid',
      type: ViewType.DEFAULT,
      filters: this.getDefaultFilters(),
      displayedColumns: DISPLAYED_COLUMNS,
      pageSize: DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      compactView: false,
    };

    return {
      view,
      columns: getColumnDetails(),
    };
  }

  private getDefaultFilters(): Filter<ColumnKeys>[] {
    let filters = [{ [ColumnKeys.EXCLUSION_EVENT_TYPE]: { in: [] } }, { [ColumnKeys.EXCLUSION_FIELD]: { in: [] } }];

    if (Application.Main.canHaveChildCompanies()) {
      filters = [
        { [ColumnKeys.COMPANY]: { exactMatch: this.dependencies.getUser().company.id ?? null } } as any,
        ...filters,
      ];
    }

    return filters;
  }
}
